export default __webpack_public_path__ + "static/critical-infrastructure-illustration-54187f80a439b49be010f4ebe9e012d4.svg";